module.exports = "<a [routerLink]=\"['/']\"> <img src=\"assets/images/logo.png\" width=\"200\" height=\"30\" alt=\"\"> </a>\r\n"